import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
import { PlatformLocation} from '@angular/common';
declare var app;

@Component({
  selector: 'app-mz-grid-list-notice',
  templateUrl: './mz-grid-list-notice.component.html',
  styleUrls: ['./mz-grid-list-notice.component.scss']
})
export class MzGridListNoticeComponent extends GridBaseCase {

  month: any = new Date();
  searchDate = null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  unReadMsgType = {type1:0,type2:0,type3:0,type4:0};//未读消息类型
  checkMsgType = 2;//选中消息类型
  numberNum : any;
  numberNum2 : any;
  numberNum3 : any;
  numberNum4 : any;
  searchValue:string = null;//查询内容
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    private platformlocation:PlatformLocation
  ) { super(); }

    ngOnInit(){
      //显示列表的信息提示未读的接口调用
      const that = this;
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "UnReadMsgCount";
      body.OpType = "query";
      body.ConfigType = "view";
      body.Client.PageName = null;
      body.Client.ApiType = "Element";
      body.Client.Name = null;
      body.Client.ClientType = 1;
      that.http.post(app.DEFAULTURL, body).then(data => {
        console.log("zm 列表数据")
        console.log(data)
        data.Status.Datas.forEach( itbum =>{
          // MsgType  Num
          switch(itbum.MsgType) {
            case 1:
               that.numberNum = itbum.Num;
               if(that.numberNum >1){

               }
               break;
            case 2:
              that.numberNum2 = itbum.Num;
               break;
            case 3:
              that.numberNum3 = itbum.Num;
              // that.numberNum3 = 66;
             
            break;
            case 4:
              that.numberNum4 = itbum.Num;
            break;  
          } 
         
          
        })
        
      });
      this.LoadData(1);
    }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    const that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body: WebParameterContext = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.Account = that.com.GetAccount;
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.Name = pageName;
    body.Client.PageName = pageName;
    // if (that.platform.is("android")) {
    //   body.Client.ClientType = 0;
    // } else if (that.platform.is("ios")) {
    //   body.Client.ClientType = 1;
    // }
    // body.RequestBody = JSON.stringify({ 'a_ID': id });
    // if (!that.searchDate) {
    //   let nowyear: any = that.com.getNow.split('-')[0];
    //   let nowmonth: any = that.com.getNow.split('-')[1];
    //   // obj["startDate"] = nowyear + "-" + nowmonth;
    //   let startDate = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
    //   let day = new Date(nowyear, nowmonth, 0);
    //   let endDate = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
     
    //   that.searchDate = that.com.BetweenDate(startDate, endDate);
    // }
    // if (that.searchDate) {
    //   // body.RequestBody = JSON.stringify({ "a_ModifyTime": that.searchDate,"b_Addressee":that.com.GetAccount.Id });
    //   if(that.checkMsgType == 0){
    //     body.RequestBody = JSON.stringify({ "a_SendTime": that.searchDate});
    //   }else{
    //     body.RequestBody = JSON.stringify({ "a_SendTime": that.searchDate, "a_MsgType": that.checkMsgType});
    //   }
    // }
    if(that.searchValue){
      let  a_Theme={
        "Value":that.searchValue,
        "LikeType":"Middle",
        "Type":"Like"
      };
      body.RequestBody = JSON.stringify({ "a_MsgType": that.checkMsgType,a_Theme:a_Theme});
    } else{
      body.RequestBody = JSON.stringify({ "a_MsgType": that.checkMsgType});
    }
    
    
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    // console.log("1008611");
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          objfield["read"]=item["a_IsRead"];
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = item[element.field];
            }
            if (element.bindingField == 'date' && item[element.field]) {
              objfield[element.bindingField] = item[element.field].replace('00:00:00', '').replace(/-/g,"/");
            }
           
          });
          that.dataArrayList.push(objfield);
          console.log("xisnhi拼接数据拼接数据￥￥￥￥￥￥￥￥￥￥￥￥￥￥￥￥￥￥")
          console.log(that.dataArrayList);
        });
        let readCount:number = 0;
        that.dataArrayList.forEach(coutitem=>{
          if(that.checkMsgType == 0){
            that.unReadMsgType["type"+coutitem.msgType] = false;
          }
          if(that.checkMsgType == coutitem.msgType){
            that.unReadMsgType["type"+coutitem.msgType] = false;
          }

          if(!coutitem.status){
            readCount+=1;

            //判断哪种消息类型具有未读的消息
            if(that.checkMsgType == 0){
              that.unReadMsgType["type"+coutitem.msgType] = true;
            }
            if(that.checkMsgType == coutitem.msgType){
              that.unReadMsgType["type"+coutitem.msgType] = true;
            }
          }
        });
        if(readCount){
          localStorage.setItem("readCount",readCount.toString());
        }else{
          localStorage.removeItem("readCount");
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      } else {
        console.log(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.loading = true;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;

      console.log(error);
    })
  }
    /**
   * 搜索事件
   * @param e 
   */
     serarEvent(e,type:string = 'type'){ 
      const that = this;
      if(e.keyCode == 13 || type=='search'){
        
        that.LoadData(1);
      }
    }
  EventLink(ev: any, parms: any) {
    const that = this;
    let evs = ev.url || '';
    
    if (evs.trim() && parms) {
      that.com.setHistoryUrl();
      if (evs.indexOf("http") > 0) {
        that.com.goWebPage(evs, '详情');

        console.log(evs, parms);
      } else {
        // localStorage.setItem('element', JSON.stringify(ev));
        // localStorage.setItem('elementParms', JSON.stringify(parms));
        // if(that.platformlocation["location"].hash.replace('#','')){
        //   localStorage.setItem("backurl",that.platformlocation["location"].hash.replace('#',''));
        // }
        console.log(parms);
       
        if(parms.read==0){
          that.readNotice(parms);
        }
       
        // that.router.navigateByUrl(evs + "View/" + parms.id+"&"+that.com.getNowDatetime);
        that.com.Go(evs + "View/" + parms.id+"&"+that.com.getNowDatetime);
        
      }
    }

  }



  changeMonth(type, $event:any = "") {
    let t = type;
    let current = new Date(this.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = this.getmonth(current.getMonth());
    } else if (t == 'next') {
      current_year = current.getFullYear();
      current_month = this.getmonth(current.getMonth() + 2);
    } else if (t == 'datetime') {
      console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = 1;
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    this.searchDate = this.com.BetweenDate(startmonthDay, endmonthDay);
    this.month = current_year + '-' + current_month;
    if (t == 'datetime') {
      this.LoadData(1);
    }
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }

  /**
   * 设置消息为已读
   * @param parms 
   */
  readNotice(parms) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "MarkMessageRead";//临时拜访
    body.OpType = "add";
    body.ConfigType = "form";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Content";
    body.Client.Name = null;
    body.Client.ClientType = 2;
    let arrayobj = { "type": 1, "ids": [] };
    // let IDs = that.actRouter.snapshot.paramMap.get('id');
    let _arrayobj = {};
    _arrayobj["ID"] = parms.id;
    _arrayobj["MsgType"] = parms.msgType;
    arrayobj.ids.push(_arrayobj);
    // console.log(arrayobj,'arrayobj');
    body.RequestBody = JSON.stringify(arrayobj);
      that.http.post(app.DEFAULTURL, body).then(
        data => {
          if (data.ResponseMessage.Success) {
            let arrayalert:Array<any>=new Array<any>();
            let recount:number =0;
            if(localStorage.getItem("readCount")){

               recount = Number.parseInt(localStorage.getItem("readCount"));
            }
            
            let messageUnlock = that.com.GetStorageKey("lock");
            if(messageUnlock){
              if(messageUnlock.alertmessage.length>0){
                messageUnlock.alertmessage.forEach(item=>{
                  if(item.id!=parms.id){
                    arrayalert.push(item);
                  }else{
                    recount-=1;
                  }
                });
              }
              messageUnlock.alertmessage=arrayalert;
              localStorage.setItem("lock",JSON.stringify(messageUnlock));
              localStorage.setItem("readCount",recount.toString());
            }
          }
        }
      )
  }

  /**
   * 加载对应类型的消息
   * @param num 消息对应类型
   */
  loadMsgTypeData(num){
    // if(this.checkMsgType == num){
    //   this.checkMsgType = 0;
    // }else{
    //   this.checkMsgType = num;
    // }
    this.checkMsgType = num;
    this.LoadData(1);
  }
}
